import type { Affinity, ObjectDefinitionResult } from '@thinkalpha/table-client';
import { createInstance } from 'src/api';
import { appConfig } from 'src/lib/config/appConfig';

type CreateTableObjectRequest = {
    persist: boolean;
    definitions: unknown;
    affinity?: Affinity;
};

type CreateTableObjectResponse = {
    success: boolean;
    message?: string;
};

const api = createInstance();

export const createTableObject = async (
    useNgProxy: boolean,
    payload: CreateTableObjectRequest,
): Promise<ObjectDefinitionResult> => {
    const response = await api.post<CreateTableObjectResponse>('/tables', payload, {
        baseURL: useNgProxy ? appConfig.httpNgTableProxy : appConfig.tableProxy,
    });
    return {
        success: response.data.success,
        comment:
            response.data.message ?? (response.data.success ? 'Table defined successfully.' : 'Failed to define table'),
    };
};
